import React, { useState } from "react";
import { Document, Page, pdfjs, View } from "react-pdf";
import { Button, Dropdown, Menu, Modal, Select, Space } from "antd";
import GeneralBloc from "../../../bloc/general_bloc";
import './pdf_viewer.css';
import { ReactComponent as DownloadIcon } from "../../../Download2.svg";

pdfjs.GlobalWorkerOptions.workerSrc = `${GeneralBloc.getAssetsContextPath()}/assets/javascript/pdf.worker.js`;

export default function PDFViewer(props) {
  const [numPages, setNumPages] = useState(null);
  const [pagesRendered, setPagesRendered] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const styles = {
    page: {
      flexDirection: "row",
      backgroundColor: "#fff",
      width: "100%",
      orientation: "portrait",
    },
    view: {
      width: "100%",
      height: "100%",
      padding: 0,
      backgroundColor: "white",
    },
    image: {
      objectFit: "cover",
    }
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPagesRendered(1);
  }

  function onRenderSuccess() {
    setPagesRendered(pagesRendered + 1)
  }

  function handleScroll(e) {
    let totalHeight = e.target.scrollHeight;
    let currentHeight = e.target.scrollHeight - e.target.scrollTop;
    let heightPerPage = e.target.scrollHeight / numPages;
    let currentPage = (totalHeight - currentHeight) / heightPerPage;
    currentPage = (currentPage + 1).toFixed(0) > numPages ? (currentPage).toFixed(0) : (currentPage + 1).toFixed(0);
    setCurrentPage(currentPage);
  }

  function viewImage() {
    return <div className="col-md-12 text-left">

      <div className="w-100 d-flex justify-content-center">
        <img className="img-fluid" style={{ objectFit: "cover" }}
          src={props.content}
        />
      </div>

    </div>
  }

  function handleDownload() {
    const linkSource = props.content;
    const downloadLink = document.createElement("a");
    const fileName = props.title;
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  function viewPDF() {
    return (
      <div style={{ height: '75vh', overflowY: 'scroll', backgroundColor: 'white' }} onScroll={(e) => handleScroll(e)}>

        <Document
          style={{ margin: "0px" }}
          file={content}
          options={{
            workerSrc: "/pdf.worker.js", useSystemFonts: true,
            standardFontDataUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/standard_fonts/`,
            cMapUrl: "https://unpkg.com/pdfjs-dist@latest/cmaps/",
            cMapPacked: true,
          }}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={console.error}
        >
          {Array.from(new Array(pagesRenderedPlusOne), (el, index) => {
            const isCurrentlyRendering = pagesRenderedPlusOne === index + 1;
            const isLastPage = numPages === index + 1;
            const needsCallbackToRenderNextPage = isCurrentlyRendering && !isLastPage;
            return (
              <Page
                renderMode="canvas"
                width="500"
                margin="0px"
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                style={styles.page}
                size="A4"
                onRenderSuccess={
                  needsCallbackToRenderNextPage ? onRenderSuccess : null
                }
              >
                <hr></hr>
              </Page>
            )

          })}
        </Document>
      </div>
    )
  }
  
  const { content } = props;

  const pagesRenderedPlusOne = Math.min(pagesRendered + 1, numPages);
  return (
    <Modal
      open={props.open}
      onCancel={props.handleModalClose}
      footer={null}
      width={props.width}
      closable={props.closable}
    >
      <div className="justify-content-between d-flex text_outside_modal mb-2" >
        {props.title}
        <div style={{ cursor: 'pointer' }} onClick={() => handleDownload()}><DownloadIcon fill={'#FFFFFF'} /></div>
      </div>
      {
        props?.document == 'pdf' || props?.document == 'PDF' ?
          viewPDF() : viewImage()
      }
      {
        (props?.document == 'pdf' || props?.document == 'PDF') &&
        <div className="justify-content-center d-flex text_outside_modal" >
          {currentPage} / {numPages} Pages
        </div>
      }

    </Modal>

  );
}
